var GlobalCallOptionsBuilder = /** @class */ (function () {
    function GlobalCallOptionsBuilder() {
        this.callOptions = {
            waitAudio: {
                url: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/f6b85378-c03a-4915-96ae-8a72a9e4f1e6/2018/04/09/3f3f8e91-5eaa-4c79-9c98-3d741fa45f63.mpga',
                name: 'GeneralWaiting.mp3'
            },
            holdAudio: {
                url: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/f6b85378-c03a-4915-96ae-8a72a9e4f1e6/2018/04/09/3f3f8e91-5eaa-4c79-9c98-3d741fa45f63.mpga',
                name: 'GeneralHold.mp3'
            },
            voiceMailMessageLengthMinutes: 2
        };
    }
    GlobalCallOptionsBuilder.prototype.withWaitAudio = function (audioFile) {
        this.callOptions.waitAudio = audioFile;
        return this;
    };
    GlobalCallOptionsBuilder.prototype.withHoldAudio = function (audioFile) {
        this.callOptions.holdAudio = audioFile;
        return this;
    };
    GlobalCallOptionsBuilder.prototype.withVoiceMailMessageLengthMinutes = function (minutes) {
        this.callOptions.voiceMailMessageLengthMinutes = minutes;
        return this;
    };
    GlobalCallOptionsBuilder.prototype.build = function () {
        return this.callOptions;
    };
    return GlobalCallOptionsBuilder;
}());
export { GlobalCallOptionsBuilder };
//# sourceMappingURL=call-options.builder.js.map